import React, { PropTypes } from 'react';
import TcDayPickerSet from '../../../tc-ui/date-picker-set';
import FlatButton from '../../../tc-ui/flat-button-with-loader';
import { FontIcon } from 'material-ui';
import uuid from 'node-uuid';
import R, { remove, insert } from 'ramda';
import SyncSectionCheckbox from './sync-section-checkbox';
import DateUtils from '../../../../utils/date-utils';

const Blackouts = ({ onRequestClose, contractingPeriod, onTextFieldChangeWithKeyPath, contractId, productId, saveProductInfoChanges, data, saving }) => {
  const blackoutsLength = R.pathOr(0, ['blackouts', 'length'], data);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
      <div style={{ padding: '0 32px 16px' }}>
        <br/>
        <small>
          <p>
            Enter a blackout date to let your partners know which dates you are not operating or accepting bookings;
            for instance, if you are closed on Christmas Day, you can add it as a blackout date.
          </p>
          <p>
            Tip: If your blackout has just one date, you can select the start date only.
          </p>
        </small>
        {
          data.blackouts.map((blackout, index) => {
            const initialStartDateMonth = (() => {
              if (blackout.startDate) return blackout.startDate;
              if (blackout.endDate) return blackout.endDate;
              if (blackoutsLength > 1 && index) return data.blackouts[index - 1].endDate || data.blackouts[index - 1].startDate;
              return contractingPeriod.startDate;
            })();
            const initialEndDateMonth = (() => {
              if (blackout.endDate) return blackout.endDate;
              if (blackout.startDate) return blackout.startDate;
              if (blackoutsLength > 1 && index) return data.blackouts[index - 1].endDate || data.blackouts[index - 1].startDate;
              return contractingPeriod.startDate;
            })();
            return (
              <div key={blackout.dataKey} style={{ marginBottom: index === blackoutsLength - 1 ? '20px' : '0' }}>
                <TcDayPickerSet
                  showTextField
                  endDateCloseOnSelect
                  startDateCloseOnSelect
                  disableDeleteButton={blackoutsLength === 1}
                  textFieldStyle={{ display: 'inline-block', width: '20%', fontSize: '12px' }}
                  startDateContainerStyle={{ display: 'inline-block', marginLeft: '3%', width: '25%' }}
                  startDateTextFieldStyle={{ width: '100%', fontSize: '12px' }}
                  endDateContainerStyle={{ display: 'inline-block', marginLeft: '3%', width: '25%' }}
                  endDateTextFieldStyle={{ width: '100%', fontSize: '12px' }}
                  addButtonStyle={{ marginLeft: '16px', lineHeight: '24px', verticalAlign: 'middle' }}
                  deleteButtonStyle={{ marginLeft: '16px', lineHeight: '24px', verticalAlign: 'middle' }}
                  textFieldFloatingText="Name"
                  startDateFloatingText="Start Date"
                  endDateFloatingText="End Date"
                  initialStartDateMonth={initialStartDateMonth}
                  startDateEnableFrom={contractingPeriod.startDate}
                  startDateEnableTo={contractingPeriod.endDate}
                  initialEndDateMonth={initialEndDateMonth}
                  endDateEnableFrom={blackout.startDate || contractingPeriod.startDate}
                  endDateEnableTo={contractingPeriod.endDate}
                  textFieldValue={blackout.name}
                  startDate={blackout.startDate}
                  endDate={blackout.endDate}
                  textFieldOnChange={e => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'blackouts', index, 'name'], value: e.target.value })}
                  onChangeStartDate={value => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'blackouts', index, 'startDate'], value })}
                  onChangeEndDate={value => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'blackouts', index, 'endDate'], value })}
                  onDelete={() => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'blackouts'], value: remove(index, 1, data.blackouts) })}
                  onAdd={() => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'blackouts'], value: insert(index + 1, { dataKey: uuid.v1() }, data.blackouts) })}
                  startDateErrorText={data.startDateRequired && !blackout.startDate ? data.startDateRequired : ''}
                />
                {
                  blackout.startDate && blackout.endDate
                  && DateUtils.notInContractingPeriod([blackout], contractingPeriod.startDate, contractingPeriod.endDate) ?
                    (
                      <div style={{ color: '#f44336', fontSize: '12px', display: 'flex', width: '80%', alignItems: 'center', marginBottom: '12px' }}>
                        <FontIcon className="tc-icon-report" style={{ color: '#f44336', marginRight: '4px' }}/>
                        Not in contracting period, please UPDATE or REMOVE
                      </div>
                    ) : <span/>
                }
              </div>
            );
          })
        }
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0px 8px 0px 12px' }}>
        <SyncSectionCheckbox
          sectionInEdit="blackouts"
          labelStyle={{ width: '70%' }}
          style={{ width: '55%', top: '6px' }}
        />
        <div>
          <FlatButton
            label="Cancel"
            labelStyle={{ fontWeight: '600' }}
            primary
            onTouchTap={onRequestClose}
          />
          <FlatButton
            label="Save"
            loader={saving}
            labelStyle={{ fontWeight: '600' }}
            onTouchTap={() => {
              if (data.blackouts.some(blackout => !blackout.startDate && (blackout.endDate || blackout.name))) onTextFieldChangeWithKeyPath({ keyPath: ['data', 'startDateRequired'], value: 'Required' });
              else saveProductInfoChanges({ contractId, productId, data, updateType: 'SAVED_BLACKOUT_DAYS' });
            }}
            secondary
          />
        </div>
      </div>
    </div>
  );
};

Blackouts.propTypes = {

};

export default Blackouts;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/blackouts.jsx